import * as THREE from "three";
import SpriteText from "three-spritetext";
import type { UserDataObject } from "../types/scene";

function getFirstChildData(visibleEl: THREE.Object3D) {
  const firstChild = visibleEl.children[0];
  return {
    child: firstChild,
    userData: (firstChild?.userData || {}) as UserDataObject,
  };
}

export function serializeLineWithPositions(visibleEl: THREE.Object3D & { userData: UserDataObject }) {
  return {
    name: visibleEl.name,
    isBetweenInteracted: visibleEl.userData.isBetweenInteracted,
    positions: visibleEl.userData.positions,
    sourceCenter: (visibleEl.userData.positions as { sourceCenter?: unknown })?.sourceCenter,
    targetCenter: (visibleEl.userData.positions as { targetCenter?: unknown })?.targetCenter,
  };
}

export function serializeTextBlock(visibleEl: THREE.Object3D) {
  const { child, userData } = getFirstChildData(visibleEl);
  return {
    name: visibleEl.name,
    content: userData.content,
    blockType: userData.blockType,
    blockID: userData.blockID,
    creationDate: userData.creationDate,
    generatedTitle: userData.generatedTitle,
    htmlContent: userData.htmlContent,
    source: userData.source,
    title: userData.title,
    user: userData.user,
    connections: userData.connections,
    position: child?.position,
    direction: userData.direction,
  };
}

export function serializeChannel(visibleEl: THREE.Object3D) {
  const { child, userData } = getFirstChildData(visibleEl);
  return {
    name: visibleEl.name,
    text: (visibleEl as SpriteText).text,
    position: child?.position,
    direction: userData.direction,
    spritescale: child?.scale,
    active: userData.active,
    blockType: userData.blockType,
    channelData: userData.channelData,
    connection: userData.connection,
    contentRendered: userData.contentRendered,
  };
}

export function serializePlaneBlock(visibleEl: THREE.Object3D & { userData: UserDataObject }) {
  return {
    position: visibleEl.position,
    blockID: visibleEl.userData.blockID,
    blockType: visibleEl.userData.blockType,
    connections: visibleEl.userData.connections,
    content: visibleEl.userData.content,
    creationDate: visibleEl.userData.creationDate,
    description: visibleEl.userData.description,
    direction: visibleEl.userData.direction,
    generatedTitle: visibleEl.userData.generatedTitle,
    htmlContent: visibleEl.userData.htmlContent,
    positionUserData: visibleEl.userData.position,
    source: visibleEl.userData.source,
    title: visibleEl.userData.title,
    user: visibleEl.userData.user,
  };
}
